import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { useClientId } from '../../../../_hooks/useClientId';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../CommonUtils/urlWithParams';
import { Donor, GivingStrategy, KindOfProperty } from './useCharitableGivingQuery';
import { useCharitableGivingContext } from '../context/useCharitableGivingContext';

export interface AccountDTO {
  id: string;
  name: string;
  institution: string | null;
  balance: number;
}

interface FetcherParams {
  clientId: number;
  givingStrategy: GivingStrategy | null;
  kindOfProperty: KindOfProperty | null;
  donor: Donor | null;
}

export const fetchAccounts = async ({
  clientId,
  givingStrategy,
  kindOfProperty,
  donor,
}: FetcherParams): Promise<AccountDTO[]> => {
  return authFetch(
    urlWithParams(
      '/Consumer/CharitableGivingWorkflow/Accounts',
      {
        clientId,
        strategy: givingStrategy,
        kindOfProperty,
        donor,
      },
      { skipNulls: true },
    ),
  );
};

export const useAccountsQuery = () => {
  const clientId = useClientId();

  const {
    workflow: {
      data: { givingStrategy, donor, kindOfProperty },
    },
  } = useCharitableGivingContext();

  return useQuery(
    queryKeys.accounts(clientId, givingStrategy, kindOfProperty, donor),

    () => fetchAccounts({ clientId, givingStrategy, kindOfProperty, donor }),

    {
      cacheTime: 0,
      enabled: givingStrategy !== null,
    },
  );
};
